import { keepPreviousData, useQuery } from "@tanstack/react-query";

import meetingService from "@services/meeting.service";
import { MEETING_OBJECTS_QUERY_KEY, QUERY_CACHE_SHORT_EXPIRATION_MS } from "@config/query";
import useMeetingStore from "@store/useMeetingStore";

export function useMeetingObjects(enabled: boolean) {
  const { meetingId } = useMeetingStore();
  return useQuery({
    enabled: enabled && Boolean(meetingId),
    queryKey: [MEETING_OBJECTS_QUERY_KEY, meetingId],
    queryFn: async () => {
      return meetingService.getMeetingObjects(meetingId);
    },
    staleTime: QUERY_CACHE_SHORT_EXPIRATION_MS,
    retry: false,
    placeholderData: keepPreviousData,
  });
}
